import { db } from "../../config/firebase/firebase-config";
import { TypeUser } from "../../enums/enums";
import Axios from "axios";
import { IInitialSettled } from "../../redux/types/types";
import { EntityForm } from "../../module/superAdmin/form/EntityFrom";

export const getEntities = async (): Promise<EntityForm[] | null> => {
  try {
    const usersSnap = await db
      .collection("Users")
      .where("rol", "==", TypeUser.ADMIN)
      .get();

    const result: EntityForm[] = [];

    for (const doc of usersSnap.docs) {
      const userData = doc.data() as EntityForm;

      if (!userData.nit || !userData.entityType) {
        const idEntity = userData.idEntity;

        if (idEntity) {
          const entityDoc = await db.collection("Entities").doc(idEntity).get();
          if (entityDoc.exists) {
            const entityData = entityDoc.data();
            const mergedEntity: EntityForm = {
              ...userData,
              nit: userData.nit || entityData?.nit || "",
              entityType: userData.entityType || entityData?.entityType || "",
            };
            result.push(mergedEntity);
            continue;
          }
        }
      }

      result.push(userData);
    }

    return result;
  } catch (error) {
    console.error("[ERROR] al obtener entidades:", error);
    return null;
  }
};

export const validateEmailInMailjet = (email: string) => {
  return Axios.post(
    "https://us-central1-modulosmialcaldia.cloudfunctions.net/validateMailInMailjet",
    {
      email: email,
    }
  )
    .then((resp: any) => {
      const { data } = resp;

      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getEntity = (nit: string): Promise<any> => {
  return db
    .collection("Users")
    .where("rol", "==", TypeUser.ADMIN)
    .where("nit", "==", nit)
    .limit(1)
    .get()
    .then((snapShot) => {
      let users: any;
      snapShot.forEach((doc: any) => {
        users = {
          id: doc.id,
          ...(doc.data() as any),
        };
      });

      return users;
    })
    .catch((err) => console.log(err));
};
export const getEntityById = (id: string): Promise<any> => {
  return db
    .collection("Users")
    .where("rol", "==", TypeUser.ADMIN)
    .where("idEntity", "==", id)
    .limit(1)
    .get()
    .then((snapShot) => {
      let users: any;
      snapShot.forEach((doc: any) => {
        users = {
          id: doc.id,
          ...(doc.data() as any),
        };
      });

      return users;
    })
    .catch((err) => console.log(err));
};

export const getDataFromEntities = (id: string): Promise<any> => {
  return db
    .collection("Entities")
    .where("nit", "==", id)
    .limit(1)
    .get()
    .then((snapshot) => {
      let entity: any;
      snapshot.forEach((doc: any) => {
        entity = {
          admin: doc.admin,
          ...(doc.data() as any),
        };
      });
      return entity;
    })
    .catch((err) => console.log(err));
};

/* CARGAR PARAMETRIZACION INITIAL SETTLED A ENTITY */
export const loadInitialSettledDb = async (idEntity: string) => {
  const param = await db.collection("Entities").doc(idEntity).get();
  return (param.data() as any).initialSettled;
};

/* AGREGAR SUBCOLLECTION SIGNATURE */
export const addInitialSettledDb = async (
  idEntity: string,
  initialSettled: IInitialSettled
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .set(
        {
          ...initialSettled,
        },
        { merge: true }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};
